import { useState } from "react";
import {
  Select,
  SelectValue,
  SelectContent,
  SelectTrigger,
  SelectLabel,
  SelectItem,
  SelectGroup,
} from "../ui/select";
import { Typography } from "@mui/material";
import { User } from "@/interfaces/User";
import DialogRoleConfirm from "../DialogRoleConfirm";
import { useSelector } from "react-redux";
import { userSelector } from "@/redux/user/user.selector";

const roles = [
  {
    value: "Administrador",
    label: "Administrador",
  },
  {
    value: "Cliente",
    label: "Cliente",
  },
  {
    value: "MRM",
    label: "MRM",
  },
];

interface RoleCellProps {
  user: Partial<User>;
}

export const RoleCell = ({ user }: RoleCellProps) => {
  const [newRole, setNewRole] = useState<string>("");
  const { userInfo } = useSelector(userSelector).ui;
  const [selectedRole, setSelectedRole] = useState<string>(
    user.role || "Administrador",
  );
  const [openConfirm, setOpenConfirm] = useState(false);

  const handleRoleChange = (value: string) => {
    setNewRole(value);
    setOpenConfirm(true);
  };

  return (
    <>
      {userInfo?.role === "Administrador" ? (
        <Select value={selectedRole} onValueChange={handleRoleChange}>
          <SelectTrigger className="w-[150px]">
            <SelectValue placeholder="Selecciona un rol" />
          </SelectTrigger>
          <SelectContent>
            <SelectGroup>
              <SelectLabel>
                <Typography
                  fontFamily={"Inter"}
                  fontSize={"12px"}
                  fontWeight={400}
                  className="text-gray-500"
                >
                  Roles
                </Typography>
              </SelectLabel>
              {roles.map((role) => (
                <SelectItem
                  key={role.value}
                  value={role.value}
                  isSelected={selectedRole === role.value}
                >
                  <Typography
                    fontFamily={"Inter"}
                    fontSize={"14px"}
                    fontWeight={400}
                  >
                    {role.label}
                  </Typography>
                </SelectItem>
              ))}
            </SelectGroup>
          </SelectContent>
        </Select>
      ) : (
        <Typography fontFamily={"Inter"} fontSize={"14px"} fontWeight={400}>
          {user.role}
        </Typography>
      )}

      <DialogRoleConfirm
        open={openConfirm}
        setOpen={setOpenConfirm}
        userInfo={user}
        newRole={newRole}
        setSelectedRole={setSelectedRole}
      />
    </>
  );
};
